import { render, staticRenderFns } from "./BusRentInfo.vue?vue&type=template&id=20de1610&scoped=true&"
import script from "./BusRentInfo.vue?vue&type=script&lang=js&"
export * from "./BusRentInfo.vue?vue&type=script&lang=js&"
import style0 from "./BusRentInfo.vue?vue&type=style&index=0&id=20de1610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de1610",
  null
  
)

export default component.exports